export const parseCSV = (file, onUpdate) => (
  new Promise((resolve, reject) => {
    const reader = new window.FileReader();
    reader.readAsText(file);
    reader.onload = () => {
      onUpdate({ name: file.name, size: file.size });
      const [headers, ...rows] = reader.result.split('\n');
      const separator = headers.includes(',') ? ',' : ';';
      const serializedHeaders = headers.split(separator);
      const serializedRows = rows
        .map((row) => row.split(separator))
        .filter((row) => row.length > 1); // remove empty lines

      resolve({
        // used to create teams review
        headers: serializedHeaders,
        rows: serializedRows,
        // will be sent to backend
        original: reader.result,
      });
    };
    reader.onerror = (error) => reject(error);
  })
);
